import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { UserProfileType, UserRegisterType } from "@/types/view";
import { UserService } from "@/services";
import { useSnackbar } from "@/hooks";
import { PathConstant, SystemConstant } from "@/const";

export const useAddUser = () => {
  const { t: getLabel } = useTranslation();
  const { openSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const registerUserMutation = useMutation({
    mutationFn: (payload: UserRegisterType) => UserService.registerUser(payload),
    onSuccess: () => {
      openSnackbar(getLabel("MSG_ADD_SUCCESS"), "success");
      navigate(PathConstant.MN_USER);
    },
    onError: () => openSnackbar(getLabel("MSG_ADD_FAILURE"), "error"),
  });

  const registerUser = (newProfile: UserProfileType) => {
    registerUserMutation.mutate({ ...newProfile, role: SystemConstant.ROLE.user });
  };

  return {
    registerUser,
  };
};
